import "./styles.css";

const TextBox = ({ text }) => {
  return <p className="textBox">{text}</p>;
};

export { TextBox };
